import { number, object, string } from 'yup';

export const resgateParcialPercentuaisSchema = object({
  contaIndividual: number(),
  contaAdicional: number(),
  contaEventual: number(),
  contaPortabilidadeAberta: number(),
  // eslint-disable-next-line func-names
}).test('pelo-menos-um-preenchido', null, function (obj) {
  const {
    contaIndividual,
    contaAdicional,
    contaEventual,
    contaPortabilidadeAberta,
  } = obj;
  if (
    !contaIndividual &&
    !contaAdicional &&
    !contaEventual &&
    !contaPortabilidadeAberta
  ) {
    return this.createError({
      path: 'contas',
      message: 'Selecione um valor válido',
    });
  }
  return true;
});

export const resgateParcialRegimeSchema = object({
  opcaoRegimeTributacao: string().required(),
});

export const resgateParcialBancariosSchema = object({
  codigoBanco: number().required('Escolha um banco válido'),
  agencia: string()
    .required('Preencha a agência')
    .test(
      'is-four-digits',
      'A agência deve ter 4 dígitos númericos',
      (value) => {
        if (!value) return false;
        // eslint-disable-next-line no-restricted-globals
        return value.toString().length === 4 && !isNaN(Number(value));
      }
    ),
  contaCorrente: number('Conta corrente é um campo númerico').required(
    'Preencha o número da conta'
  ),
  digito: string()
    .required('Preencha o dígito verificador')
    .length(1, 'Digito é limitado a 1 caracter'),
});
